var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.583,
    height: 16.583,
    viewBox: "0 0 16.583 16.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,17.625v3.454H7.954L18.142,10.891,14.688,7.437Zm16.313-9.4a.917.917,0,0,0,0-1.3L18.658,4.766a.917.917,0,0,0-1.3,0L15.673,6.451l3.454,3.454L20.813,8.22Z",
    transform: "translate(-4.5 -4.496)",
    fill: "#ebd61f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.5151a36ccd08029f1940880158b05936.svg";
export { ForwardRef as ReactComponent };